const LineHeight = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M39.4453 33.7915L39.4453 28.5001C39.4453 25.1567 41.4181 22.4819 43.8364 22.4819L74.6376 22.4819C77.0771 22.4819 79.0286 25.1858 79.0286 28.5001L79.0286 33.7915"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.2383 72.5815L59.2383 25.6187"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.9297 72.585L70.2094 72.585"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4805 25.3101L22.4805 73.3755"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1337 28.1372L22.479 22.4824L16.8242 28.1372"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1337 67.7207L22.479 73.3755L16.8242 67.7207"
        stroke="black"
        strokeWidth="5.08929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LineHeight;
